// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"cfce585d","117":"d40bfcda","133":"11b004ce","205":"0541b502","210":"ea810404","318":"436a4258","488":"be905c86","611":"3be50529","663":"064a5953","665":"e3b86ddc","727":"4b915b67","763":"11ef72dd"}[chunkId] + ".chunk.js";
};